export const CART_ORDER_STATUS = {
  NEW: 'new',
  PROCESSING: 'processing',
  DONE: 'done',
  CANCELLED: 'cancelled',
}

const PENDING_TICKET_STATUS = 1
const PRINTED_TICKET_STATUSES = [2, 3, 4, 5, 9, 44]
const CANCELLED_TICKET_STATUSES = [6, 7, 8]

const CART_ORDER_STATUS_LABELS = {
  [CART_ORDER_STATUS.NEW]: 'Đơn mới',
  [CART_ORDER_STATUS.PROCESSING]: 'Đang in',
  [CART_ORDER_STATUS.DONE]: 'Đã in xong',
  [CART_ORDER_STATUS.CANCELLED]: 'Đã hủy',
}

const CART_ORDER_STATUS_DESCRIPTIONS = {
  [CART_ORDER_STATUS.NEW]: 'Còn vé chờ in và chưa in được vé nào',
  [CART_ORDER_STATUS.PROCESSING]: 'Đã in một phần, vẫn còn vé chờ in',
  [CART_ORDER_STATUS.DONE]: 'Không còn vé chờ in',
  [CART_ORDER_STATUS.CANCELLED]: 'Toàn bộ vé trong đơn đã bị hủy',
}

const CART_ORDER_STATUS_VARIANTS = {
  [CART_ORDER_STATUS.NEW]: 'warning',
  [CART_ORDER_STATUS.PROCESSING]: 'info',
  [CART_ORDER_STATUS.DONE]: 'success',
  [CART_ORDER_STATUS.CANCELLED]: 'danger',
}

const CART_ORDER_STATUS_TEXTS = {
  [CART_ORDER_STATUS.NEW]: 'dark',
  [CART_ORDER_STATUS.PROCESSING]: 'dark',
}

export const getCartOrderStatus = (tickets) => {
  if (!Array.isArray(tickets) || tickets.length === 0) return null

  if (tickets.every(ticket => CANCELLED_TICKET_STATUSES.includes(ticket.status))) {
    return CART_ORDER_STATUS.CANCELLED
  }

  const hasPending = tickets.some(ticket => ticket.status === PENDING_TICKET_STATUS)
  const hasPrinted = tickets.some(ticket => PRINTED_TICKET_STATUSES.includes(ticket.status))

  if (hasPending) {
    return hasPrinted ? CART_ORDER_STATUS.PROCESSING : CART_ORDER_STATUS.NEW
  }
  if (hasPrinted) return CART_ORDER_STATUS.DONE

  return null
}

export const getCartOrderStatusLabel = (status) => CART_ORDER_STATUS_LABELS[status] ?? 'Không xác định'

export const getCartOrderStatusDescription = (status) => CART_ORDER_STATUS_DESCRIPTIONS[status] ?? ''

export const getCartOrderStatusVariant = (status) => CART_ORDER_STATUS_VARIANTS[status] ?? 'secondary'

export const getCartOrderStatusText = (status) => CART_ORDER_STATUS_TEXTS[status] ?? 'light'

export const CART_ORDER_STATUS_OPTIONS = [
  CART_ORDER_STATUS.NEW,
  CART_ORDER_STATUS.PROCESSING,
  CART_ORDER_STATUS.DONE,
  CART_ORDER_STATUS.CANCELLED,
].map(status => ({
  value: status,
  label: CART_ORDER_STATUS_LABELS[status],
  description: CART_ORDER_STATUS_DESCRIPTIONS[status],
}))
